interface IFilterValues {
  type?: string;
  status?: string;
  [key: string]: any;
}

const generateFilter = (values: IFilterValues): string =>
  Object.keys(values)
    .filter((el) => !!values[el])
    .map((el) => {
      switch (el) {
        case "type":
        case "status":
        case "developerCompany":
          return `${el}=${values[el]}`;
        default:
          return el;
      }
    })
    .join(",");

export default generateFilter;
